import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';
import {TMedalhaLevel} from "../../../app/enum";
import {LogadoService} from "../../../providers/logado-service";
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {CONFIG} from "../../../app/config";

@Component({
    selector: 'page-medalha-menu',
    templateUrl: 'medalha-menu.html'
})
export class MedalhaMenuPage {

    TMedalhaLevel: any = TMedalhaLevel;

    config: any;
    logado: any;
    perfil: any;

    etapa: number;

    //etapa 2
    filho: number;
    medalha: any;

    constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,
                public logadoService: LogadoService, public util: Util) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.perfil = (this.navParams.get('perfil') && this.logado.Profile.ProfileID != this.navParams.get('perfil').Profile.ProfileID ? this.navParams.get('perfil') : this.logado);

        this.etapa = this.navParams.get('etapa');

        this.filho = this.navParams.get('filho');
        this.medalha = this.navParams.get('medalha');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Medalha', '/medalha-menu');

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    medalhaMenu(index: number, filho: number) {

        let objectData = {etapa: 1, perfil: this.perfil, medalha: this.perfil.Medalhas[index], filho: filho};
        this.util.modalopen(MedalhaMenuPage, 'quad', true, objectData).subscribe();

    }

    dismiss() {

        this.viewCtrl.dismiss();
        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/medalha-menu/medalha-menu.ts